module.exports = __webpack_public_path__ + "static/media/992054.843683b8.png";